<template>
  <input
    v-money="money"
    v-model.lazy="inputValue"
    @keydown="handleKeyDown"
    @input="handleInput"
    class="emd-input"
    v-bind="$attrs"
  />
</template>

<script>
import { VMoney } from 'v-money'
import TextManager from '@/utils/text.manager'
import { NUMBER_FORMAT_ENUM } from './number-format.enum'

export default {
  name: 'EmdInputMoney',
  directives: { money: VMoney },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    decimal: {
      type: String,
      default: () => ','
    },
    thousands: {
      type: String,
      default: () => '.'
    },
    prefix: {
      type: String,
      default: () => 'R$'
    },
    suffix: {
      type: String,
      default: () => ''
    },
    precision: {
      type: Number,
      default: () => 2
    },
    numberFormat: {
      type: String,
      default: () => NUMBER_FORMAT_ENUM.INTEGER,
      validation: (value) => Object.values(NUMBER_FORMAT_ENUM).includes(value)
    }
  },
  data () {
    return {
      inputValue: ''
    }
  },
  computed: {
    convertedValue () {
      if (typeof this.inputValue !== 'string') return 0
      const value = Number(TextManager.removeNonDigits(this.inputValue))
      if (this.numberFormat === NUMBER_FORMAT_ENUM.INTEGER) {
        return value
      }

      return value / 100
    },
    money () {
      return {
        thousands: this.thousands,
        decimal: this.decimal,
        prefix: this.prefix + ' ',
        suffix: ' ' + this.suffix,
        precision: this.precision
      }
    }
  },
  methods: {
    handleKeyDown (event) {
      const key = event.key
      if (key === '-') {
        event.preventDefault()
      }
    },
    handleInput () {
      this.$emit('input', this.convertedValue)
    }
  },
  created () {
    this.inputValue = this.value
  }
}
</script>
